var past_box = {
  product: []
}
class customJS  {
  constructor () {
    this.bodyElement = document.querySelector("[body-element]");
    this.bodyElement.querySelectorAll("[data-subscribe-popup]").forEach(ele=>{
      ele.addEventListener('click',(event)=>{
          this._openSubscribe(event);
      })
    });
    this.bodyElement.addEventListener('click',(event)=>{
      this._closeSubscribe(event);
    })
    if (document.querySelector('.gift-of-meat')) {
      this._equalheightafterload();
    }
    if (document.querySelector('#what-39-s-in-the-box-us-carnivore-club')) {
      this._initClassicProduct();
    }
  }

  _equalheightafterload() {
    if (window.screen.width > 767) {
      var maxDescHeight = 0;
      const descElement = document.querySelectorAll('.subscription-products .sub-product-description');
      descElement.forEach((ele, key) => {
        const element = ele.querySelector('.sub-product-desc');
        if (element.offsetHeight > maxDescHeight) {
          maxDescHeight = element.offsetHeight;
        }
      });
      descElement.forEach((ele, key) => {
        ele.querySelector('.sub-product-desc').style.minHeight = maxDescHeight + 'px';
      });
    }
  }

  _openSubscribe(event){
    let parentElement = event.currentTarget.parentElement;
    parentElement.querySelector("[data-subscriber-description]").classList.add("show");
  };

  _closeSubscribe(event){
    if (!event.target.matches('[data-subscribe-popup]')) {
      this.bodyElement.querySelectorAll("[data-subscriber-description]").forEach(ele=>{
        if(ele.classList.contains("show"))ele.classList.remove("show")
      })
    }
  }

  _initClassicProduct(){
    document.querySelectorAll('[data-classic-product-json]').forEach((item) => {
      const prodObj = item.innerHTML;
      const prodData = JSON.parse(prodObj);
      past_box.product.push(prodData);

      document.querySelector('#past-boxes-product').innerHTML = '';
      if (past_box.product !== null) {
        past_box.product.forEach((product) => {
          document.querySelector('#past-boxes-product').innerHTML += 
          `
            <div class="col-lg-6 col-md-6 col-12 card-group">
            <div class="card bg-white text-left border-0 shadow-none rounded-0 mb-sm-4 mb-5">
              <div class="card-img rounded-0 position-relative">
                <img
                  src="${product.product.featured_image}"
                  class=" h-100 top-left-50 w-100"
                  alt="${product.product.title}"
                />
              </div>
              <div class="card-body pb-2">
                <h2 class="h4 text-uppercase mb-2"><a alt="${product.product.title}" href="/products/${product.product.handle}" class="text-black">${product.product.title}</a></h2>
                <p class="h5 mb-3 font-weight-light">${product.product.description}</p>
              </div>
            </div>
          </div>
          `;
        })
      }
    })
  }
}

new customJS();

const breakpoint = window.matchMedia( '(min-width:768px)' );
let mySwiper;

const breakpointChecker = function() {
  if ( breakpoint.matches === true ) {
    if ( mySwiper !== undefined ) mySwiper.destroy( true, true );
    return;
  } else if ( breakpoint.matches === false ) {
    return enableSwiper();
  }

};
const enableSwiper = function() {

  mySwiper = new Swiper ('.featured_in-slider .swiper-container', {
    slidesPerView: "auto"
  });

};
breakpoint.addListener(breakpointChecker);
breakpointChecker();